import { Component, OnInit } from '@angular/core';
import { ManageComponentsService } from '../modules/manage-components/manage-components.service';
import { LoadingService } from '../shared/services/loading.service';
import { GetComponentImageData, LisComponentImageTypeVM } from '../modules/manage-components/manage-components.model';
import { ComponentTypeImagesVM, PhotoModelComingFrom, PreInspectionChecklistVM, UpdateComponentImageViewModel } from '../modules/GET_NEW_UI/inspections/inspection.model';
import { GETViewPhotoComponent } from '../modules/GET_NEW_UI/shared/view-photo/view-photo.component';
import { DomSanitizer } from '@angular/platform-browser';
import { FileReaderEvent } from '../shared/models/FileReader';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../app.service';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-setup-component-type',
  templateUrl: './setup-component-type.component.html',
  styleUrls: ['./setup-component-type.component.scss']
})
export class SetupComponentTypeComponent implements OnInit {
  imageList: GetComponentImageData;
  imagedata: UpdateComponentImageViewModel;
  Image: string;
  photoLoading: boolean = false;
  selectedSechamnticImage: File
  constructor(private _appService: AppService,
    private _componentservice: ManageComponentsService,
    private _dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private _loadingService: LoadingService,
    private notification: NotificationsService,
  ) {
  }

  ngOnInit() {
    this._appService.setPageTitle('Component Types');
    this.loadComponentImage();

  }

  loadComponentImage() {
    this._loadingService.startLoading();
    this._componentservice.loadComponentImage().subscribe((response: any) => {
      this._loadingService.finishedLoading();
      this.imageList = response;

    });
  }

  viewObservationImage(img: any, preChecklist: ComponentTypeImagesVM) {
    //console.log("Image_selected,", img)
    const passingData = {
      comingFrom: PhotoModelComingFrom.DisplayComponentImageType,
      image: img,
      compart_attach_auto: preChecklist.compart_attach_auto
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      if (changes) {
        this.loadComponentImage();

      }
    });
  }

  viewCompartImage(img: any, imageId: number, CompartTypeId: number) {
    //console.log("Image_selected,", img)
    const passingData = {
      comingFrom: PhotoModelComingFrom.DisplayComponentImageType,
      image: img,
      imageId: imageId,
      compart_attach_auto: CompartTypeId
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      if (changes) {
        this.loadComponentImage();

      }
    });
  }

  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }
  }
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }

  onSelectPhoto(event: any, toolId: any, ComponentId: any) {
    this.photoLoading = true;
    var filename = event.target.files[0].name;
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    this.selectedSechamnticImage = event.target.files[0]
    reader.onload = (event: any) => { // called once readAsDataURL is completed
      var imageUrl = (event.target.result).split(',');
      this.addComponentToolImages(imageUrl[1], this.selectedSechamnticImage, toolId, ComponentId);
    }
  }

  onComponentImageChange(event: any, ComponentId: any, ImageId: number) {
    this.photoLoading = true;
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    this.selectedSechamnticImage = event.target.files[0]
    reader.onload = (event: any) => { // called once readAsDataURL is completed
      var imageUrl = (event.target.result).split(',');
      this._componentservice.addComponentImages(imageUrl[1], ImageId, ComponentId).subscribe((response: any) => {
        this.photoLoading = false;
        this.notification.success("Image Uploaded Successfully.")
        this.loadComponentImage();
      });
    }
  }

  uploadPhoto(newPhoto: string) {
    this.Image = newPhoto.split(",")[1];
  }
  addComponentToolImages(imageUrl: string, imageName: File, toolId: any, ComponentId: any) {
    this._componentservice.addComponentToolImages(imageUrl, imageName.name, toolId, ComponentId).subscribe((response: any) => {
      this.photoLoading = false;
      this.notification.success("Image Uploaded Successfully.")
      this.loadComponentImage();


    });
  }
}
